import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
    _excluded2 = ["show", "appear", "unmount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import T, { Fragment as W, createContext as q, useContext as U, useEffect as S, useMemo as z, useRef as c, useState as j } from "react";
import { Features as de, forwardRefWithAs as k, render as J, RenderStrategy as m } from "../../utils/render.js";
import { OpenClosedProvider as fe, State as V, useOpenClosed as K } from "../../internal/open-closed.js";
import { match as R } from "../../utils/match.js";
import { microTask as Te } from "../../utils/micro-task.js";
import { useId as pe } from "../../hooks/use-id.js";
import { useIsMounted as me } from "../../hooks/use-is-mounted.js";
import { useIsoMorphicEffect as ce } from "../../hooks/use-iso-morphic-effect.js";
import { useLatestValue as I } from "../../hooks/use-latest-value.js";
import { useServerHandoffComplete as Q } from "../../hooks/use-server-handoff-complete.js";
import { useSyncRefs as X } from "../../hooks/use-sync-refs.js";
import { useTransition as he } from "../../hooks/use-transition.js";
import { useEvent as Y } from "../../hooks/use-event.js";

function h() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return e.split(" ").filter(function (n) {
    return n.trim().length > 1;
  });
}

var N = q(null);
N.displayName = "TransitionContext";

var ge = function (t) {
  return t.Visible = "visible", t.Hidden = "hidden", t;
}(ge || {});

function ve() {
  var e = U(N);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}

function Ce() {
  var e = U(L);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}

var L = q(null);
L.displayName = "NestingContext";

function w(e) {
  return "children" in e ? w(e.children) : e.current.filter(function (_ref) {
    var n = _ref.state;
    return n === "visible";
  }).length > 0;
}

function Z(e) {
  var n = I(e),
      t = c([]),
      r = me(),
      s = Y(function (l) {
    var _R;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : m.Hidden;
    var a = t.current.findIndex(function (_ref2) {
      var u = _ref2.id;
      return u === l;
    });
    a !== -1 && (R(o, (_R = {}, _defineProperty(_R, m.Unmount, function () {
      t.current.splice(a, 1);
    }), _defineProperty(_R, m.Hidden, function () {
      t.current[a].state = "hidden";
    }), _R)), Te(function () {
      var u;
      !w(t) && r.current && ((u = n.current) == null || u.call(n));
    }));
  }),
      g = Y(function (l) {
    var o = t.current.find(function (_ref3) {
      var a = _ref3.id;
      return a === l;
    });
    return o ? o.state !== "visible" && (o.state = "visible") : t.current.push({
      id: l,
      state: "visible"
    }), function () {
      return s(l, m.Unmount);
    };
  });
  return z(function () {
    return {
      children: t,
      register: g,
      unregister: s
    };
  }, [g, s, t]);
}

function be() {}

var Se = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];

function $(e) {
  var t;
  var n = {};

  for (var _i = 0, _Se = Se; _i < _Se.length; _i++) {
    var r = _Se[_i];
    n[r] = (t = e[r]) != null ? t : be;
  }

  return n;
}

function Ee(e) {
  var n = c($(e));
  return S(function () {
    n.current = $(e);
  }, [e]), n;
}

var xe = "div",
    ee = de.RenderStrategy,
    te = k(function (n, t) {
  var _R3;

  var r = n.beforeEnter,
      s = n.afterEnter,
      g = n.beforeLeave,
      l = n.afterLeave,
      o = n.enter,
      a = n.enterFrom,
      u = n.enterTo,
      A = n.entered,
      v = n.leave,
      E = n.leaveFrom,
      x = n.leaveTo,
      y = _objectWithoutProperties(n, _excluded),
      d = c(null),
      D = X(d, t),
      _j = j("visible"),
      _j2 = _slicedToArray(_j, 2),
      i = _j2[0],
      C = _j2[1],
      p = y.unmount ? m.Unmount : m.Hidden,
      _ve = ve(),
      b = _ve.show,
      re = _ve.appear,
      ne = _ve.initial,
      _Ce = Ce(),
      H = _Ce.register,
      P = _Ce.unregister,
      F = c(null),
      f = pe();

  S(function () {
    if (!!f) return H(f);
  }, [H, f]), S(function () {
    if (p === m.Hidden && !!f) {
      var _R2;

      if (b && i !== "visible") {
        C("visible");
        return;
      }

      R(i, (_R2 = {}, _defineProperty(_R2, "hidden", function hidden() {
        return P(f);
      }), _defineProperty(_R2, "visible", function visible() {
        return H(f);
      }), _R2));
    }
  }, [i, f, H, P, b, p]);
  var ie = I({
    enter: h(o),
    enterFrom: h(a),
    enterTo: h(u),
    entered: h(A),
    leave: h(v),
    leaveFrom: h(E),
    leaveTo: h(x)
  }),
      se = Ee({
    beforeEnter: r,
    afterEnter: s,
    beforeLeave: g,
    afterLeave: l
  }),
      O = Q();
  S(function () {
    if (O && i === "visible" && d.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [d, i, O]);

  var M = ne && !re,
      oe = function () {
    return !O || M || F.current === b ? "idle" : b ? "enter" : "leave";
  }(),
      _ = c(!1),
      B = Z(function () {
    _.current || (C("hidden"), P(f));
  });

  he({
    container: d,
    classes: ie,
    events: se,
    direction: oe,
    onStart: I(function () {
      _.current = !0;
    }),
    onStop: I(function (ue) {
      _.current = !1, ue === "leave" && !w(B) && (C("hidden"), P(f));
    })
  }), S(function () {
    !M || (p === m.Hidden ? F.current = null : F.current = b);
  }, [b, M, i]);
  var le = y,
      ae = {
    ref: D
  };
  return T.createElement(L.Provider, {
    value: B
  }, T.createElement(fe, {
    value: R(i, (_R3 = {}, _defineProperty(_R3, "visible", V.Open), _defineProperty(_R3, "hidden", V.Closed), _R3))
  }, J({
    ourProps: ae,
    theirProps: le,
    defaultTag: xe,
    features: ee,
    visible: i === "visible",
    name: "Transition.Child"
  })));
}),
    G = k(function (n, t) {
  var _R4;

  var r = n.show,
      _n$appear = n.appear,
      s = _n$appear === void 0 ? !1 : _n$appear,
      g = n.unmount,
      l = _objectWithoutProperties(n, _excluded2),
      o = c(null),
      a = X(o, t);

  Q();
  var u = K();
  if (r === void 0 && u !== null && (r = R(u, (_R4 = {}, _defineProperty(_R4, V.Open, !0), _defineProperty(_R4, V.Closed, !1), _R4))), ![!0, !1].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");

  var _j3 = j(r ? "visible" : "hidden"),
      _j4 = _slicedToArray(_j3, 2),
      A = _j4[0],
      v = _j4[1],
      E = Z(function () {
    v("hidden");
  }),
      _j5 = j(!0),
      _j6 = _slicedToArray(_j5, 2),
      x = _j6[0],
      y = _j6[1],
      d = c([r]);

  ce(function () {
    x !== !1 && d.current[d.current.length - 1] !== r && (d.current.push(r), y(!1));
  }, [d, r]);
  var D = z(function () {
    return {
      show: r,
      appear: s,
      initial: x
    };
  }, [r, s, x]);
  S(function () {
    if (r) v("visible");else if (!w(E)) v("hidden");else {
      var C = o.current;
      if (!C) return;
      var p = C.getBoundingClientRect();
      p.x === 0 && p.y === 0 && p.width === 0 && p.height === 0 && v("hidden");
    }
  }, [r, E]);
  var i = {
    unmount: g
  };
  return T.createElement(L.Provider, {
    value: E
  }, T.createElement(N.Provider, {
    value: D
  }, J({
    ourProps: _objectSpread(_objectSpread({}, i), {}, {
      as: W,
      children: T.createElement(te, _objectSpread(_objectSpread({
        ref: a
      }, i), l))
    }),
    theirProps: {},
    defaultTag: W,
    features: ee,
    visible: A === "visible",
    name: "Transition"
  })));
}),
    ye = k(function (n, t) {
  var r = U(N) !== null,
      s = K() !== null;
  return T.createElement(T.Fragment, null, !r && s ? T.createElement(G, _objectSpread({
    ref: t
  }, n)) : T.createElement(te, _objectSpread({
    ref: t
  }, n)));
}),
    We = Object.assign(G, {
  Child: ye,
  Root: G
});
export { We as Transition };